let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cmuoB")).then(() => parcelRequire('ff3ab'));